if(window.Shopify.country == 'US') {
    setTimeout( function() {
        const paybadge = document.querySelector('.paybadge[aria-label="Afterpay"]');
        const paybadgeExpanded = document.querySelectorAll(".payopts-expanded .payopts-item:last-child .paybadge");
        const footerBancontact = document.querySelectorAll(".footer__aside .bancontact");
        const ideal = document.querySelectorAll(".footer__aside .ideal");
        const truckBadge = document.querySelectorAll(".product-info__block-group.feature-badge-list .feature-badge");
        const truckParagraph = truckBadge[0].querySelector('p');

        if(paybadge) {
            paybadge.classList.add('us-pay-badge');
            paybadgeExpanded[0].classList.add('us-pay-badge');
        }
        if(footerBancontact) {
            footerBancontact[0].classList.add('hide');
        }
        if(ideal) {
            ideal[0].classList.add('hide');
        }
        if(truckBadge) {
            if(truckParagraph.textContent === 'Free UK Delivery') {
                truckParagraph.textContent = 'Free USA shipping over $180';
            }
        }
    }, 1000);
}